// extracted by mini-css-extract-plugin
export default {"wrapper":"Y8vqiZJCBkNlT3D9N4RM","highlightZone":"i0DLjLATVBVmnMA1Msp2","periodsList":"DfoPTABDkyQbATWwofMp"};